import React, {useEffect, useState} from 'react';
import '../Setzliste.css';
import NavbarLiga from "../components/NavbarLiga";
import ApiService from "../services/ApiService";
import Setzliste from "../Setzliste";

function Ab10mkSetzliste() {
    const [loading, setLoading] = useState(false);
    const [ligaList, setLigaList] = useState([]);
    const [selectedLiga, setSelectedLiga] = useState(null);


    const [mannschaftenList, setMannschaftenList] = useState(null);
    const [setzlisteData, setSetzlisteData] = useState({});

    const handleLigaClick = (selectedLiga) => {
        setSelectedLiga(selectedLiga);
        setMannschaftenList(null);

        ApiService.fetchMannschaftenByLiga(2026, selectedLiga.id)
            .then(data => {
                setMannschaftenList(data);
                return Promise.all(data.map(entry => {
                    return ApiService.fetchSetzliste(2026, entry.mannschaft.id)
                        .then(setzliste => ({mannschaftId: entry.mannschaft.id, setzliste}))
                }));
            })
            .then(results => {
                const newSetzlisteData = {};
                results.forEach(({mannschaftId, setzliste}) => {
                    newSetzlisteData[mannschaftId] = setzliste;
                });
                setSetzlisteData(newSetzlisteData);
            })
            .catch(error => console.error('Fehler beim Laden der Daten für die rechte Spalte:', error));
    };

    useEffect(() => {
        setLoading(true);
        ApiService.fetchLigenByDisziplin("AB10mk")
            .then(data => {
                setLigaList(data);
                setLoading(false);
            })
            .catch(error => console.error('Fehler beim Laden der Ligen:', error));
    }, []);

    if (loading) {
        return <p>Loading...</p>;
    }

    return (
        <div className="element-content element-background">
            <div className="grid-show-liste">
                <div className="top-panel-liste">
                    <NavbarLiga ligaList={ligaList} handleLigaClick={handleLigaClick} selectedLiga={selectedLiga}></NavbarLiga>
                </div>
                <div className="body-panel-liste">
                    {mannschaftenList && (
                        mannschaftenList.map((current) => (
                            setzlisteData[current.mannschaft.id] && setzlisteData[current.mannschaft.id].length > 0 && (
                                <div key={current.mannschaft.id} className="setzliste-block">
                                    <label> {current.mannschaft.name} </label>
                                    <Setzliste mannschaft={current.mannschaft}
                                               setzliste={setzlisteData[current.mannschaft.id]}/>
                                </div>
                            )
                        ))
                    )}
                </div>
            </div>
        </div>
    );
}

export default Ab10mkSetzliste;